import { css } from '@emotion/core'
import * as React from 'react'

// import { Helmet } from 'react-helmet'
import { breakpoints } from '../../constants/breakPoints'
import RichTextAssetBlock from './../content-management/RichTextAssetBlock'

interface LinkedInPostProps {
  embeddedCode: string
}

const LinkedInPost: React.FunctionComponent<LinkedInPostProps> = ({ embeddedCode }) => {
  const srcMatch = embeddedCode.match(/src="([^"]+)"/)
  const src = srcMatch ? srcMatch[1] : null

  if (!src) {
    return null
  }

  return (
    <RichTextAssetBlock withoutPadding>
      {/* <Helmet>
        <script src="https://platform.linkedin.com/in.js" type="text/javascript" />
        <script type="IN/PostShare" data-url="https://www.linkedin.com/posts/username_post-identifier-123456" />
      </Helmet> */}
      <div css={linkedInContainerStyle}>
        <iframe src={src} height="100%" width="100%" frameBorder="0" allowFullScreen />
      </div>
    </RichTextAssetBlock>
  )
}

export default LinkedInPost

const linkedInContainerStyle = css`
  aspect-ratio: 16/9;
  display: flex;
  align-items: center;

  @media screen and (max-width: ${breakpoints.small}px) {
    aspect-ratio: initial;
    height: 400px;
    max-height: 75vh;
  }
`
